export const OVERPAYMENTS_URL = '/matching/overpayments'

export const OVERPAYMENT_API = '/api/internal/overpayment'
export const OVERPAYMENT_REASON_LOOKUP_API = '/api/internal/overpayment-reason/lookup'
export const CASH_BOX_PAYOUT_LOOKUP_API = '/api/internal/cash-box/payout-lookup'

export const PAY_VIA_LOCAL_ADAPTER_LABEL = 'Оплатить через локальный адаптер'

/** Подпись под бейджем статуса у записи, чья компенсационная выплата ушла на кассу */
export const VIA_CASH_BOX_LABEL = 'через кассу'

// Коды отказа возвращает бэкенд в errors.cashBoxId. Неизвестный код показываем как есть — это лучше
// пустого места, по нему можно найти причину в логах.
export const LOCAL_ADAPTER_ERROR_LABEL: Record<string, string> = {
  NOT_IN_MATCHING: 'Выплата уже не в мэтчинге',
  CASHBOX_UNAVAILABLE: 'Касса недоступна: отключена или заблокирована',
  CASHBOX_INSUFFICIENT_BALANCE: 'У кассы не хватает остатка с учётом овердрафта на эту выплату',
  DEPOSIT_IN_PROGRESS: 'По выплате идёт незавершённый депозит',
  PARTIALLY_COVERED: 'По выплате уже есть оплаченный депозит',
  ALREADY_PAID: 'Выплата уже оплачена мэтчингом',
  PLACEMENT_FAILED: 'Касса не приняла выплату, переоплата отменена — заведите новую',
  WITHDRAWN_NOT_PLACED: 'Выплата снята с мэтчинга, но на кассу не встала — повторите действие',
  LOCAL_ADAPTER_MISSING: 'Локальный адаптер не настроен',
  MATCHING_UNAVAILABLE: 'Мэтчинг недоступен, попробуйте позже',
}

export const UI_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  DECLINED: 'DECLINED',
} as const

export const UI_STATUS_LABEL: Record<keyof typeof UI_STATUS, string> = {
  IN_PROGRESS: 'В работе',
  COMPLETED: 'Завершена',
  DECLINED: 'Отменена',
}

export const OVERPAYMENTS_BREADCRUMBS = [
  { title: 'Мэтчинг', path: '/matching' },
  { title: 'Переоплаты', path: OVERPAYMENTS_URL },
]
